import {GenericEntity} from './generic-entity.model';
import {Address} from './address.model';
import {DictionaryItem} from './dictionary.model';

export class MigratedPolicy extends GenericEntity {
    id: number;
    number: string;
    partner: MigratedPolicyPartnerIdentity;
    partnerCode: string;
    partnerDescription: string;
    locationCode: string;
    locationDescription: string;
    printoutId: string;
    transId: string;
    status: DictionaryItem;
    statusTimestamp: string;
    paymentTimestamp: string;
    variantCode: string;
    insuranceSum: number;
    premium: number;
    owu: string;
    salesDocument: string;
    risks: MigratedPolicyRisk[];
    shopAddress: Address;
    insuredSubject: MigratedPolicyInsuredSubject;
    insuredPerson: MigratedPolicyInsuredPerson;
    installments: string[];
}

export class MigratedPolicyIdentity extends GenericEntity {
    assortmentGroup: string;
    id: number;
    number: string;
    owu: string;
    partnerCode: string;
    partnerDescription: string;
    partnerName: string;
    paymentDate: string;
    variant: string;
}

export class MigratedPolicyPartnerIdentity {
    active: boolean;
    address: Address;
    name: string;
    fax: string;
    phone: string;
    www: string;
}

export class MigratedPolicyRisk {
    code: string;
    end: string;
    start: string;
}

export class MigratedPolicyInsuredSubject {
    assortmentGroupCode: string;
    assortmentGroupDescription: string;
    brand: string;
    description: string;
    model: string;
    numberOfSellPolicy: string;
}

export class MigratedPolicyInsuredPerson {
    address: Address;
    companyName: string;
    mail: string;
    name: string;
    nip: string;
    partyType: string;
    partyTypeDictionary: DictionaryItem;
    pesel: string;
    regon: string;
    surname: string;
    phones: Phones;
}

export class Phones {
    CELL_1: string;
    CELL_2: string;
    HOME_1: string;
    HOME_2: string;
}
